import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class VerifyService {

    AUTH_API = `${environment.apiUrl}/open/`;

    constructor(private http: HttpClient) {
    }
    async verify(code: string): Promise<any> {
        const url = this.AUTH_API + 'verify';
        const payload = { key: 'verify_token', value: code };
        return await this.http.post<any>(url, payload).toPromise();
    }
}